import { map } from "nanostores"
import { useStore } from "./use-store"

export type Screens =
  | "Error"
  | "SignUp"
  | "SignIn"
  | "ForgotPassword"
  | "Payment"
  | "Loading"
  | "Success"
  | "SocialAuthSuccess"

type NavigationProps = {
  screen: Screens
  history: Screens[]
}

const $navigation = map<NavigationProps>({
  screen: "SignUp",
  history: [],
})

// listenKeys($navigation, ['screen', 'history'], (store, key) => {
//   // eslint-disable-next-line no-console
//   console.log(key, store[key])
// })

export const useNavigation = () => useStore($navigation)

export function navigate(newScreen: Screens): void {
  const { screen, history } = $navigation.get()
  if (newScreen === screen) return

  const newHistory = [...history, screen]

  $navigation.setKey("screen", newScreen)
  $navigation.setKey("history", newHistory)
}

export function replace(newScreen: Screens): void {
  $navigation.setKey("screen", newScreen)
}

export function goBack(): void {
  const { history } = $navigation.get()
  const newHistory = [...history]
  const screen = newHistory.pop()

  if (screen == null) return

  $navigation.setKey("screen", screen)
  $navigation.setKey("history", newHistory)
}

export function clear(): void {
  $navigation.setKey("history", [])
}

export function startAt(screen: Screens): void {
  $navigation.set({
    screen,
    history: [],
  })
}
